import React from 'react';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import MechanismSection from './components/MechanismSection';
import SolutionSection from './components/SolutionSection';
import ForWhomSection from './components/ForWhomSection';
import DifferentiationSection from './components/DifferentiationSection';
import BonusSection from './components/BonusSection';
import ProductSection from './components/ProductSection';
import AuthoritySection from './components/AuthoritySection';
import ProductDemoSection from './components/ProductDemoSection';
import CredibilitySection from './components/CredibilitySection';
import FAQSection from './components/FAQSection';
import GuaranteeSection from './components/GuaranteeSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import PurchaseSuccess from './components/PurchaseSuccess';
import { Toaster } from './components/ui/sonner';
import { useScrollReveal } from './hooks/useScrollReveal';

const CHECKOUT_URL = "https://pay.hotmart.com/T104325827P?checkoutMode=10";

function handleCTAClick() {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout');
  }
  window.location.href = CHECKOUT_URL;
}

function LandingPage() {
  useScrollReveal();

  return (
    <>
      <Hero onCTAClick={handleCTAClick} />
      <ProblemSection />
      <MechanismSection />
      <SolutionSection />
      <ForWhomSection />
      <DifferentiationSection />
      <BonusSection />
      <ProductSection onCTAClick={handleCTAClick} />
      <AuthoritySection />
      <ProductDemoSection />
      <CredibilitySection />
      <FAQSection />
      <GuaranteeSection />
      <FinalCTA onCTAClick={handleCTAClick} />
      <Footer />
      <Toaster position="top-center" />
    </>
  );
}

function App() {
  const path = window.location.pathname;

  return (
    <ErrorBoundary>
      <div className="App">
        {path === '/purchase-success' ? <PurchaseSuccess /> : <LandingPage />}
      </div>
    </ErrorBoundary>
  );
}

export default App;
